module.exports = __webpack_public_path__ + "static/img/banner_case.146e9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_case.png
// module id = Cg9h
// module chunks = 16